// extracted by mini-css-extract-plugin
export default {"container":"switcher-table-cell_container__KxXeT"};